import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PagingResponse, Reviewer } from "./models/reviewer.model";
import { map, Observable } from "rxjs";
import { Country } from "./models/country.model";
import { Language } from "./models/language.model";
import { GeneralSpecialty } from "./models/general-specialty.model";
import { FormioAppConfig } from "dp-formio";

export const PAGE_SIZE = 10;

@Injectable({ providedIn: 'root' })
export class OrgService {
    private baseUrl = this.formioAppConfig.gateway;

    constructor(private formioAppConfig: FormioAppConfig,
        private http: HttpClient) {
    }

    getCountries(): Observable<Country[]> {
        return this.http.get<any[]>(`${this.formioAppConfig.formio.appUrl}countriesinformation/submission`, {
            params: {
                limit: `${Number.MAX_SAFE_INTEGER}`,
            },
        }).pipe(
            map(result => {
                return result.map(item => {
                    const model: Country = {
                        ...item.data,
                        _id: item._id
                    };
                    return model;
                });
            })
        );
    }

    getLanguages(): Observable<Language[]> {
        return this.http.get<any[]>(`${this.formioAppConfig.formio.appUrl}manuallanguage/submission`, {
            params: {
                limit: `${Number.MAX_SAFE_INTEGER}`,
            },
        }).pipe(
            map(result => {
                return result.map(item => {
                    const model: Language = {
                        ...item.data,
                        _id: item._id
                    };
                    return model;
                });
            })
        );
    }

    getGeneralSpecialty(): Observable<GeneralSpecialty[]> {
        return this.http.get<any[]>(`${this.formioAppConfig.formio.appUrl}specializationname/submission`, {
            params: {
                limit: `${Number.MAX_SAFE_INTEGER}`,
            },
        }).pipe(
            map(result => {
                return result.map(item => {
                    const model: GeneralSpecialty = {
                        ...item.data,
                        _id: item._id
                    };
                    return model;
                });
            })
        );
    }
    getLocalResidenceCity(): Observable<GeneralSpecialty[]> {
        return this.http.get<any[]>(`${this.formioAppConfig.formio.appUrl}ksacitieslistresource/submission`, {
            params: {
                limit: `${Number.MAX_SAFE_INTEGER}`,
            },
        }).pipe(
            map(result => {
                return result.map(item => {
                    const model: GeneralSpecialty = {
                        ...item.data,
                        _id: item._id
                    };
                    return model;
                });
            })
        );
    }

    getReviewers(params: any, isMassar: boolean = false): Observable<PagingResponse<Reviewer>> {
        const endpoint = !isMassar ?
            this.formioAppConfig.endpoints.customReviewersAvailable :
            this.formioAppConfig.endpoints.customMasarReviewersAvailable;
        const url = `${this.baseUrl}${endpoint}`;
        return this.http.get<any>(url, {
            observe: 'response',
            params: params
        }).pipe(
            map((response) => {
                return {
                    totalItems: Number(response.headers.get('x-total-count')),
                    data: response.body,
                    size: params?.size ?? PAGE_SIZE,
                    page: params?.page ?? 0,
                };
            })
        );
    }

    getByEndpoint(url: string): Observable<any> {
        return this.http.get<any>(url);
    }
}

